module.exports = __webpack_public_path__ + "media/images/icons/headset-outline-5973be8393686b2a3e03dff421130d2b.svg";